import React from 'react';

export default () => (
  <div>
    <h1>Book de visite</h1>
    <p>
      Vous n'êtes pas autorisé à accéder à cette fonctionnalité.
    </p>
  </div>
);



// WEBPACK FOOTER //
// ./shared/src/pages/UnauthorizedPage.jsx